<template>
  <v-menu>
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        color="primary"
        dark
        small
        fab
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="item in questionsList"
        :key="item.type"
        @click="handleQuestionSelect(item)"
      >
        <v-list-item-title>
          <v-icon class="mr-3">
            {{ item.icon }}
          </v-icon>
          {{ item.label }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import { Component, Prop, Vue, Mixins, Emit } from 'vue-property-decorator'

import { IScreeningQuestion, ScreeningQuestionType, IScreeningQuestionTypeItem } from '@/types/models/screeningQuestion.model'
import { QUESTION_TYPES_MAP, QUESTIONS_LIST } from '@/constants'

@Component
export default class ScreeningQuestionsMenu extends Vue {
  questionsList: IScreeningQuestionTypeItem[] = QUESTIONS_LIST

  handleQuestionSelect (question: IScreeningQuestionTypeItem) {
    this.$emit('select', question)
  }
}
</script>
